import React, { useState } from 'react';
import { motion } from "framer-motion";
import {
  Link,
} from "react-router-dom";
import { finishAccount } from "../resources/utils";

import Media from "../components/Media";
import Loading from "../components/Loading";

import styles from './Enable.module.scss';

const variants = {
  enter: {
    x: 1000,
    opacity: 0
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: {
    zIndex: 0,
    x: -1000,
    opacity: 0
  }
};

const inputVariants = {
  normal: {
    x: 0,
    boxShadow: "0px 4px 20px rgba(29, 29, 30, 0.1)"
  },
  hasError: {
    x: [-10, 0, 10, 0, -5, 0, 5, 0],
    boxShadow: "0px 2px 10px rgba(252, 78, 106, 0.6)"
  }
}

const Enable = ({ config, id, callback = () => {} }) => {
  const [dob, setDob] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  if(loading) {
    return (
      <Loading />
    )
  }

  return (
    <motion.div
    className={styles.enable}
    variants={variants}
    initial="enter"
    animate="center"
    exit="exit"
    transition={{
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 }
    }}
    drag="x"
    dragConstraints={{ left: 0, right: 0 }}
    dragElastic={0.5}
    >
      <div className={styles.top}>
        <Media image={config.logo} />
        <span>You're nearly there!</span>
      </div>
      <p>Add your birthday to enable your account.</p>
      <motion.div
        className={styles.dateWrapper}
        variants={inputVariants}
        initial={false}
        animate={error ? "hasError" : "normal"}
        transition={{ duration: 0.5 }}
      >
        <span>{ dob ? new Date(dob).toLocaleDateString() : 'DD/MM/YY' }</span>
        <input
          type="date" value={dob} onChange={e => {
            if(e.target.value) {
              setDob(e.target.value);
              setError(false);
            }
        }}/>
      </motion.div>
      <button onClick={async() => {
        if(!dob) {
          setError(true);
        } else {
          setLoading(true);
          let dateString = new Date(dob).toISOString();
          let birthday = await finishAccount(dateString, id);
          callback(birthday);
        }
      }} style={{ backgroundColor: config.buttonColour ? config.buttonColour : undefined}}>
        <span>Enable Account</span>
      </button>
      <div className={styles.links}>
        <Link to="/how" className={styles.link}>
          <span>How does it work?</span>
          <div>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
          </div>
        </Link>
        <Link to="/what" className={styles.link}>
          <span>What can I get?</span>
          <div>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
          </div>
        </Link>
        <Link to="/terms" className={styles.link}>
          <span>Terms & conditions</span>
          <div>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
          </div>
        </Link>
      </div>
    </motion.div>
  )
}

export default Enable;
